export const addRelated = (list) => {
  const relatedList = document.querySelector('[data-project-related-list]');

  if (relatedList)
    relatedList.appendChild(list)
}